const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  colorBlue : '#007bff',

  colorDarkGold : '#ada089',
  colorLightkGold : '#d9c8ac',
  colorBlack : '#151412',
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"playfair-display",serif',

  primaryColor: colors.colorBlue,
  fontColor: colors.colorBlack,
  bgColor: '#ebebeb',

  ...colors,
  ...overloading
}

export default variables;